import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';


@Injectable({
  providedIn: 'root'
})
export class CompanyGroupAdminGuard  {

  constructor(private apiUsuario: ApiUsuarioService, private router: Router){}

  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkCompanyGroupAdmin();
  }

  private checkCompanyGroupAdmin(){
    const credenciais = this.apiUsuario.getCredenciais();
    if (credenciais && credenciais.companyGroupAdmin) return true
		this.router.navigate(['/cotacoes']);
		return false
  }
  
}

